import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function OfferBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Only show on mobile devices
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    if (mediaQuery.matches) return;
    let scrollTimer: ReturnType<typeof setTimeout> | null = null;
    let hasScrolled = false;
    const handleScroll = () => {
      if (hasScrolled) return;
      hasScrolled = true;
      // Show banner 5 seconds after first scroll
      scrollTimer = setTimeout(() => {
        setIsVisible(true);
      }, 5000);
      // Remove listener after first scroll detected
      window.removeEventListener('scroll', handleScroll);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimer) clearTimeout(scrollTimer);
    };
  }, []);
  useEffect(() => {
    // Get or set the countdown end time (1 hour)
    const COUNTDOWN_KEY = 'offerCountdownEnd';
    let endTime = localStorage.getItem(COUNTDOWN_KEY);
    if (!endTime) {
      // Set countdown to 1 hour from now
      const end = Date.now() + 1 * 60 * 60 * 1000;
      localStorage.setItem(COUNTDOWN_KEY, end.toString());
      endTime = end.toString();
    }
    const updateCountdown = () => {
      const now = Date.now();
      const end = parseInt(endTime!);
      const diff = end - now;
      if (diff <= 0) {
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(diff % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    // Update immediately
    updateCountdown();
    // Update every second
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleDismiss = () => {
    setIsVisible(false);
  };
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <AnimatePresence data-id="element-215">
      {isVisible && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 28,
      stiffness: 300
    }} className="fixed top-0 left-0 right-0 z-[90] shadow-2xl md:hidden" data-id="element-216">
          <div className="bg-gradient-to-r from-red-600 to-red-700 backdrop-blur-md border-b border-red-800/50" data-id="element-217">
            <div className="px-4 py-3" data-id="element-218">
              <div className="flex items-start justify-between gap-3" data-id="element-219">
                {/* Offer text - two lines */}
                <div className="flex-1 min-w-0" data-id="element-220">
                  <p className="text-white font-bold text-sm leading-tight mb-1" data-id="element-221">
                    Oferta Especial + Bonos HOY en $12.99
                  </p>
                  <p className="text-white/90 text-xs leading-tight" data-id="element-222">
                    Precio Normal $49.99 vuelve en:{' '}
                    <span className="text-yellow-300 font-bold" data-id="element-223">
                      {formatTime(timeLeft.hours)}:
                      {formatTime(timeLeft.minutes)}:
                      {formatTime(timeLeft.seconds)}
                    </span>
                  </p>
                </div>

                {/* Close button */}
                <button onClick={handleDismiss} className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-white/70 hover:text-white hover:bg-white/10 transition-colors" aria-label="Cerrar" data-id="element-224">
                  <X className="w-4 h-4" data-id="element-225" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}